import { useLocalization } from "../../hooks/useLocalization";
import { useLocalePath } from "../../hooks/useLocalePath";
import { IconWithDesc } from "../shared/IconWithDesc";
import { CommonButton } from "../shared/CommonButton";

export const Description = () => {
  const { goTo } = useLocalePath();
  const { strings } = useLocalization();
  const imgs = import.meta.env.VITE_S3_ASSET_URL;

  return (
    <section className="description-section">
      <h2 className="home-section-title mb-[clamp(1.5rem,3vh,2.25rem)]">{strings.TITLE}</h2>
      <h3 className="m-0 text-center max-md:w-full max-md:max-w-full max-md:px-1 max-md:text-[clamp(0.95rem,3.5vw,1.1rem)] max-md:leading-[1.55]">
        {strings.DESCRIPTION_SECTION.BODY}
      </h3>
      <section className="description-icons">
        <IconWithDesc
          className=""
          icon={`${imgs}/icons/fin-map.svg?react`}
          text={strings.DESCRIPTION_SECTION.MAP_DESC}
          alt={strings.DESCRIPTION_SECTION.MAP_ALT}
        />
        <IconWithDesc
          className=""
          icon={`${imgs}/icons/rift.svg?react`}
          text={strings.DESCRIPTION_SECTION.RIFT_DESC}
          alt={strings.DESCRIPTION_SECTION.RIFT_ALT}
        />
        <IconWithDesc
          className=""
          icon={`${imgs}/icons/poro.svg?react`}
          text={strings.DESCRIPTION_SECTION.PORO_DESC}
          alt={strings.DESCRIPTION_SECTION.PORO_ALT}
        />
      </section>
      <CommonButton
        className="mt-[calc(4rem*1.5)] max-md:mt-fh-big"
        text={strings.BUTTONS.READ_MORE}
        onClick={() => {
          goTo("/about");
        }}
      />
    </section>
  );
};
